import React, { useState } from 'react'
import { observer } from 'mobx-react'
import InputText from '@Components/Fields/InputText'
import { publisherShareInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import Button from '@Components/Buttons/Button'
import { Maybe } from '@Types'
import { isPublisherNameAndIpiValid } from '@App/helpers/check-publisher-is-valid'
import { checkIPIFormatWithErrors } from '@App/helpers/validate'
import { PublisherModel } from '@Entities/work/publisher-model'

interface EditSimplePublisherProps {
    publisher: PublisherModel
    title: string
    subtitle: string
    editButtonText: string
    publisherNameText: string
    validatePublisherName: (publisherName: string) => string
    returnPublisher: (publisher: PublisherModel) => void
}

const EditSimplePublisher = (props: EditSimplePublisherProps) => {
    const { publisher, title, subtitle, validatePublisherName, returnPublisher, editButtonText, publisherNameText } =
        props

    const [publisherName, setPublisherName] = useState<string>(publisher.publisherName)
    const [publisherNameError, setPublisherNameError] = useState<string>()
    const [ipiNumber, setIpiNumber] = useState<Maybe<string>>(publisher.ipiNumber)
    const [ipiNumberError, setIpiNumberError] = useState<string>()
    const [isDisabled, setIsDisabled] = useState<boolean>(
        !isPublisherNameAndIpiValid(publisher.publisherName, publisher.ipiNumber)
    )

    const publisherShare: Maybe<number> = publisher.publisherShare

    const getValue = (value: string, id: string) => {
        value = value.trim()

        switch (id) {
            case 'publisherName':
                setPublisherNameError(validatePublisherName(value))
                setPublisherName(value)
                setIsDisabled(!isPublisherNameAndIpiValid(value, ipiNumber))
                break
            case 'ipiNumber':
                setIpiNumberError(checkIPIFormatWithErrors(value))
                setIpiNumber(value.length ? value : null)
                setIsDisabled(!isPublisherNameAndIpiValid(publisherName, value.length ? value : null))
                break
            default:
                break
        }
    }

    const editPublisher = () => {
        returnPublisher({
            publisherName,
            ipiNumber: ipiNumber ? ipiNumber : null,
            publisherShare,
        })
    }

    return (
        <div className="original-publisher-sub-form-component">
            <h2>{title}</h2>
            <h5 className="medium subtitle">{subtitle}</h5>
            <InputText
                mainColor
                id="publisherName"
                label={publisherNameText}
                assistiveText="Required"
                errorMessage={publisherNameError}
                value={publisherName}
                onChange={getValue}
                isEscapeNewlines
            />
            <InputText
                mainColor
                id="ipiNumber"
                label="IPI Number"
                errorMessage={ipiNumberError}
                assistiveText="Required"
                value={ipiNumber}
                onChange={getValue}
            />
            {publisherShare !== 0 && (
                <div className={`small ${publisherShareInvalidCheck(publisherShare) ? 'red-text bold' : ''}`}>
                    <span className="grey-text-2">Publisher share</span>
                    <h1 className="percent">{publisherShare}</h1>
                </div>
            )}
            <Button mainColor type="primary" onClick={editPublisher} disabled={isDisabled}>
                {editButtonText}
            </Button>
            <div className="help-area">
                <h5 className="title">How do I add shares?</h5>
                <p className="info">
                    To edit the publisher or administrator percentage amount, return to the Add Publishers page and
                    click the Next button to edit the percentage on the next page.
                </p>
            </div>
        </div>
    )
}

export default observer(EditSimplePublisher)
